import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

interface getCartItemSliceInterface {
    isLoading: boolean;
    data: any[]; // If you have a defined Todo type, replace `any[]` with `Todo[]`
    isError: boolean;
    errorMessage: string;
  }
export const fetchTodos = createAsyncThunk("todos/fetchTodos", async (_, { rejectWithValue }) => {
  try {
    const response = await fetch("https://jsonplaceholder.typicode.com/todos");
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    return await response.json();
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

const initialState: getCartItemSliceInterface = {
    isLoading: false,
    data: [],
    isError: false,
    errorMessage: "",
  };
const getCartItemSlice = createSlice({
  name: "getCartItem",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodos.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchTodos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchTodos.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload as string || "Something went wrong" // ✅ Handles undefined errors
      });
  },
});
export default getCartItemSlice.reducer;
